import * as remoteAction from "../remoteAction";

export type GetUniqueEmailShareCountActionSuccess =
  remoteAction.MerchantRemoteResponse<"GET_SHARE_COUNT_SUCCESS", any>;
export type GetUniqueEmailShareCountActionFailure =
  remoteAction.MerchantRemoteResponse<"GET_SHARE_COUNT_FAILURE", any>;
export type GetUniqueEmailShareCountActionRequest =
  remoteAction.MerchantRemoteResponse<"GET_SHARE_COUNT_REQUEST", any>;

export interface GetUniqueEmailShareCountAction
  extends remoteAction.GetRemoteRequest {
  types: {
    request: "GET_SHARE_COUNT_REQUEST";
    success: "GET_SHARE_COUNT_SUCCESS";
    failure: "GET_SHARE_COUNT_FAILURE";
  };
}

export function getUniqueEmailShareCountAction(): GetUniqueEmailShareCountAction {
  return {
    method: "GET",
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      failure: "GET_SHARE_COUNT_FAILURE",
      request: "GET_SHARE_COUNT_REQUEST",
      success: "GET_SHARE_COUNT_SUCCESS",
    },
    https: true,
    url: `/share/shares/recipients/count`,
  };
}
